import React from 'react';
/**
 * DjayAvatar — public entry path (kept stable).
 *
 * The render primitive used to live inline here (~1619 r. god-file). It has
 * been split into a scalable `./avatar/` module
 * (MASCOT_SSOT_ARCHITECTURE_AUDIT_2026 §4.1):
 *
 *   avatar/
 *     types.ts            — all public types + SIZES + viewBox/threshold consts
 *     palette.ts          — VARIANT_COLORS (9 variants)
 *     animationStyles.ts  — singleton keyframe injection
 *     parts/Eyes|Mouth|Arms|TierElements|Accessory|BodyLayers.tsx
 *     DjayAvatarView.tsx  — orchestrator (svg shell + defs + assembly)
 *     index.ts            — barrel
 *
 * Adding a new variant/accessory/emotion: extend the union in `avatar/types.ts`
 * then add the matching branch in `avatar/palette.ts` / the relevant part-file.
 *
 * This file is preserved purely as the canonical `'./DjayAvatar'` import path
 * (re-exported by `mascot/index.ts` and imported by ~50 call-sites). It adds
 * no behaviour of its own — it just re-exports the component, `VARIANT_COLORS`
 * and every type from the avatar module, so nothing downstream changes.
 */
export { DjayAvatar, VARIANT_COLORS, SIZES, DJAY_VIEWBOX } from './avatar';
export type { DjaySize, DjayEmotion, DjayTier, DjayVariant, DjayAccessory, DjayAvatarProps, VariantColorScheme } from './avatar';